import { render, staticRenderFns } from "./ContentCommunityType.vue?vue&type=template&id=68035142&"
import script from "./ContentCommunityType.vue?vue&type=script&lang=js&"
export * from "./ContentCommunityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports